import React, { useState, useEffect } from 'react';
import aiFacts from './aiFacts';

const AiFactsDisplay = () => {
    const [currentFact, setCurrentFact] = useState('');
    const [fade, setFade] = useState(true);

    useEffect(() => {
        const getRandomFact = () => aiFacts[Math.floor(Math.random() * aiFacts.length)];
        setCurrentFact(getRandomFact());

        const interval = setInterval(() => {
            setFade(false); 
            setTimeout(() => {
                setCurrentFact(getRandomFact());
                setFade(true); 
            }, 500); 
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div 
            className="mt-4 mb-4 p-3 text-center mx-auto"
            style={{
                maxWidth: '600px',
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px'
            }}
        >
            <p style={{ color: '#ffa21f', fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>
                <i className="fa-solid fa-lightbulb me-2"></i> Interesting AI Fact
            </p>
            <p 
                className="text-white mb-0" 
                style={{ 
                    fontSize: '14px', 
                    fontStyle: 'italic',
                    opacity: fade ? 1 : 0,
                    transition: 'opacity 0.5s ease-in-out',
                    minHeight: '42px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                "{currentFact}"
            </p>
        </div>
    );
};

export default AiFactsDisplay;
